module.exports = __webpack_public_path__ + "images/emoji/cyclone.68ceb2524548e8fc32cb.png";